export var EHttpMethod;
(function (EHttpMethod) {
    EHttpMethod["GET"] = "GET";
    EHttpMethod["POST"] = "POST";
    EHttpMethod["PUT"] = "PUT";
    EHttpMethod["DELETE"] = "DELETE";
    EHttpMethod["PATCH"] = "PATCH";
    EHttpMethod["HEAD"] = "HEAD";
})(EHttpMethod || (EHttpMethod = {}));
